module.exports = __webpack_public_path__ + "static/media/max.7631c315.jpg";